import { Injectable } from '@angular/core';
import { StorageService } from '@cargos/sprintpay-services';
import { BehaviorSubject, Observable } from 'rxjs';
import { ThemeType } from '../models';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private _theme: BehaviorSubject<ThemeType> = new BehaviorSubject<ThemeType>(ThemeType.light);

    constructor(private storageService: StorageService) {
        if (!!this._theme) {
            const themeLocal: ThemeType = this.storageService.getElement('theme');
            const theme: ThemeType = (themeLocal ?? null) ? themeLocal : ThemeType.light;
            this._theme.next(theme);
        }
    }

    setTheme(theme: ThemeType): void {
        this.storageService.saveElement('theme', theme);
        this._theme.next(theme);
    }

    setDarkMode(): void {
        this._theme.next(ThemeType.dark);
    }

    setLightMode(): void {
        this._theme.next(ThemeType.light);
    }

    getTheme(): Observable<ThemeType> {
        return this._theme.asObservable();
    }

    get instant_theme(): ThemeType {
        return this._theme.value;
    }
}
